/* Helper functions */
import React from "react";
import keycode from 'keycode';
import Settings from "./settings";

var Helpers = {};

// Helpers.generateDeviceID = () => {
// 	return Math.floor(Math.random() * 10000000000 + 1);
// };

Helpers.addNewLines = (str) => {
    var finalString = '';
    while(str.length > 0) {
        finalString += str.substring(0, 64) + '\n';
        str = str.substring(64);
    }

    return finalString;
}

Helpers.getVanityLevel = (obj) => {
	let vanity = obj.VanityLevel ? obj.VanityLevel : obj.VanityLevelId;
	return parseInt(vanity, 10);
};


Helpers.isVipNumber = (vanity) => {
	if (Settings.vanity_map["" + vanity]) {
		return Settings.vanity_map["" + vanity]["name"].toLowerCase();
	}
	return "";
};

Helpers.getCardTypeCode = (type) => {
	Helpers.debugPayment("Helpers.getCardTypeCode()", type);

	let code = "";

	let low_type = type.toLowerCase();

	switch (low_type) {
		case "visa":
			code = "001";
			break;

		case "mastercard":
			code = "002";
			break;

		case "amex":
			code = "003";
			break;

		default:
			// code...
			break;
	}

	Helpers.debugPayment("Helpers.getCardTypeCode() code", code);
	return code;
};

Helpers.getCardType = (card) => {
	Helpers.debugPayment("Helpers.getCardType()");
	let types = Object.keys(Settings.formats.cards);
	let cardObj = {};
	let kard = card;

	kard = kard.replace(/x/g, "");
	kard = kard.replace(/ /g, "");
					
	cardObj.type = "";
	for (let type of types) {
		if (Settings.formats.cards[type].test(kard)) {
			cardObj.type = type;
			break;
		}
	}

	cardObj.code = Helpers.getCardTypeCode(cardObj.type);

	Helpers.debugPayment("cardObj:", cardObj);

	return cardObj;
};

Helpers.getSplitText = (text, code, push) => {
	let final = [];
	if(text){
		if (text.indexOf(code) !== -1) {
			final = text.split(code);
			final = final.map(item => {
				return <span key={item}>{item}</span>
			})
			final.splice(1, 0, <span key="push">{push}</span>);
		} else {
			final.push(<span key={text}>{text}</span>);
		}
	}
	return final;
};


Helpers.removeLines = (str) => {
    return str.replace("\n", "");
}

Helpers.arrayBufferToBase64 = (arrayBuffer) => {
    var byteArray = new Uint8Array(arrayBuffer);
    var byteString = '';
    for(var i=0; i < byteArray.byteLength; i++) {
        byteString += String.fromCharCode(byteArray[i]);
    }
    var b64 = window.btoa(byteString);

    return b64;
}

Helpers.base64ToArrayBuffer = (b64) => {
    var byteString = window.atob(b64);
    var byteArray = new Uint8Array(byteString.length);
    for(var i=0; i < byteString.length; i++) {
        byteArray[i] = byteString.charCodeAt(i);
    }

    return byteArray;
}

Helpers.base64ToString = (base) => {
  return window.atob(base); 
}


Helpers.stringToBase64 = (string) => {
  return window.btoa(string); 
}


Helpers.stringTo8bitArrayBuffer = (key) => {
	return Uint8Array.from(key, c => c.charCodeAt(0));
}

Helpers.arrayBufferToString = (buf) => {
  return String.fromCharCode.apply(null, new Uint16Array(buf));
}


Helpers.stringToArrayBuffer = (str) => {
  var buf = new ArrayBuffer(str.length*2); // 2 bytes for each char
  var bufView = new Uint16Array(buf);
  for (var i=0, strLen=str.length; i < strLen; i++) {
    bufView[i] = str.charCodeAt(i);
  }
  return buf;
}

Helpers.isMobile = () => {
	let isMobile;
	let user_agent_str = navigator.userAgent.toLowerCase();
	if (
		user_agent_str.indexOf("android") !== -1 ||
		user_agent_str.indexOf("iphone") !== -1
	) {
		isMobile = true;
	} else {
		isMobile = false;
	}
	return isMobile;
};

Helpers.emptyReject = () => {
  return new Promise((resolve, reject) => {
    reject(false);
  });
}

Helpers.emptyPromise = () => {
	return new Promise((resolve, reject) => {
			resolve(true);
		});
}

Helpers.log = function() {
	if (Settings.debug) {
		for (var i = 0; i < arguments.length; i++) {
			console.log(arguments[i]);
		}
	}
};

Helpers.debugPayment = function() {
	if (Settings.debug_payment) {
		for (var i = 0; i < arguments.length; i++) {
			console.log(arguments[i]);
		}
	}
};

Helpers.getVatPercentage = (plan) => {
	let vat_percentage = plan["PackagePrice"]["VATPercentage"];
  return parseFloat(vat_percentage, 10) * 100
};

Helpers.getPriceExcludingVat = (priceProp, plan) => {
	let vat_percentage = plan["PackagePrice"]["VATPercentage"];
  let vat_excl_factor = 100 / (100 + parseFloat(vat_percentage, 10) * 100);
  return plan.PackagePrice[priceProp] * vat_excl_factor;
};


Helpers.isExceptionRoute = () => {
	for(let exception of ['/installment-fail', '/installment-success', '/contract-request']){
		if(window.location.href.indexOf(exception) !== -1){
			return true;
		}
	}
	return false;
}

Helpers.getParams = () => {
	let params = {
		string: "",
		pieces: {}
	};
	if (window) {
		if (window.location.href.indexOf("?") !== -1) {
			let search = window.location.href.substring(
				window.location.href.indexOf("?") + 1
			);

			if (search.indexOf("#") !== -1) {
				search = search.substring(0, search.indexOf("#"));
			}

			search = search.toLowerCase();

			params.string = search;
			search = search.split("&");

			for (let v = 0; v < search.length; v++) {
				let pair = search[v].split("=");
				params.pieces[pair[0]] = pair[1];
			}
		}
	}
	return params;
};

Helpers.getPaymentReturnURL = fragment => {
	if (window.location.hash !== "") {
		// using hash
		return window.location.origin + window.location.pathname + "#/" + fragment;
	} else {
		 // using pushstate
		return window.location.origin + window.location.pathname + fragment;
	}
};

Helpers.getNumberWithCountryCode = number => {
	if (number.startsWith("0")) {
		number = number.substring(1, number.length);
		number = "971" + number;
	}
	return number;
};

Helpers.getNumberWithoutCountryCode = number => {
	if (number.startsWith("971")) {
		number = number.substring(3, number.length);
		number = "0" + number;
	}
	return number;
};

Helpers.formatPhoneNumber = (number, highlight = "") => {
	number = Helpers.getNumberWithoutCountryCode(number);

	if (highlight) {
		let split = number.split(highlight);
		let number_html = [];
		for (let piece in split) {
			for (let character of split[piece]) {
				number_html.push(
					<span key={number + "1" + Math.random()}>{character}</span>
				);
			}
			if (piece < split.length - 1) {
				for (let character of highlight) {
					number_html.push(
						<span className="vmo-highlight" key={number + "2" + Math.random()}>
							{character}
						</span>
					);
				}
			}
		}
		number_html.splice(6, 0, " ");
		number_html.splice(3, 0, " ");
		return number_html;
	} else {
		return (
			number.substring(0, 3) +
			" " +
			number.substring(3, 6) +
			" " +
			number.substring(6)
		);
	}
};

Helpers.luhn = number => {
	// var number = 4532814148937827;

	// 1. Convert to string and remove spaces
	number = number.toString().replace(/ /g, "");

	// 2. Split with empty string so it splits character by character
	var pieces = number.split("");

	// pieces = ["4", "5", "3", "2", "8", "1", "4", "1", "4", "8", "9", "3", "7", "8", "2", "7"]
	// In the above array, every item is a string. So we will convert them to number when we want to process on them

	// pop() removes last item and returns it
	var checksum = Number(pieces.pop());

	// Reverse the array for looping convenience
	pieces.reverse();

	var total = 0;

	for (var i = 0; i < pieces.length; i++) {
		// Convert the current number to integer
		pieces[i] = Number(pieces[i]);

		// If alternative number
		if (i % 2 === 0) {
			// Double it
			pieces[i] = pieces[i] * 2;
			// If result is greater than 9 then sum it or else just subtract by 9, the result is same
			if (pieces[i] > 9) {
				pieces[i] -= 9;
			}
		}

		// Add to total for sum of all the numbers
		total += pieces[i];
	}

	// if ((total * 9) % 10 == checksum) {
	// 	console.log("Valid number");
	// } else {
	// 	console.log("Invalid number");
	// }

	return (total * 9) % 10 === checksum;
};

Helpers.bytesToGBs = val => {
	return val / 1024 / 1024 / 1024;
};

Helpers.bytesToMBs = val => {
	return val / 1024 / 1024;
};

Helpers.bytesToKBs = val => {
	return val / 1024;
};

const readableStorage = (bytes) => {
    if (!bytes) return '';
    const TB = 1024 ** 4;
    const GB = 1024 ** 3;
  
    return bytes >= TB? (bytes / TB)+'TB' : (bytes / GB)+'GB';
  }

Helpers.getUnitFromBytes = val => {
	let unit = "Byte";
	if((val / 1024) >= 1024){
		if((val / 1024 / 1024) >= 1024){
			unit = "GB";
		} else {
			unit = "MB";
		}
	} else {
		unit = "KB";
	}
	return unit;
}

Helpers.roundValue = val => {
	return Math.ceil(val);
}

Helpers.getUnitValuePairFromBytes = (val, force_gb = true, round = false) => {
	let unit = force_gb? "GB": Helpers.getUnitFromBytes(val);
	let value = val;
	if(Helpers['bytesTo' + unit + "s"]){
		value = Helpers['bytesTo' + unit + "s"](val);
	}
	// @EXCEPTION: Using Helpers.roundValue to fix boosters api data issue when converting bytes to GBs 
	if(round){
		value = Helpers.roundValue(value);
	}
	return {
		value: Helpers.formatNumber(value),
		unit: unit
	}
}

Helpers.GBToBytes = val => {
	return val * 1024 * 1024 * 1024;
};

Helpers.milisecondstoMinutes = val => {
	return val / 1000 / 60;
};

Helpers.toFixedNum = (num, precision) => {
	return (+(Math.round(+(num + "e" + precision)) + "e" + -precision)).toFixed(
		precision
	);
};

Helpers.getCardPin = card => {
	return card.substr(0, 6); 
};

Helpers.getMonthYear = (date) => {
	let index_of_slash = date.indexOf("/");
	let year = parseInt("20" + date.substr(index_of_slash + 1, 2), 10 ); 
	let month = parseInt(date.substr(0, index_of_slash), 10 );
	return {
		year: year,
		month: month
	}
}

Helpers.getDateFormattedForAPI = (date) => {
	let monthYear = Helpers.getMonthYear(date);

	let formatted =
	(monthYear.month > 9 ? monthYear.month : "0" + monthYear.month) +
	"/" +
	monthYear.year;

	return formatted;
}

Helpers.excludeItemsFromArray = (array, property, value) => {
	let newarray = [];
	for(let item of array){
		if(item[property] !== value){
			newarray.push(item);
		}
	}
	return newarray;
}

Helpers.formatNumber = number => {
	let final = Helpers.toFixedNum(parseFloat(number, 10), 2);
	if (final % 1 === 0) {
		final = parseInt(final, 10)
	} else {
		final = parseFloat(final, 10).toFixed(2)
	}
	return final.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

Helpers.decimals = (number) => {
	let final = Helpers.toFixedNum(parseFloat(number, 10), 2);
	if (final % 1 === 0) {
		final = parseInt(final, 10).toFixed(2);
	} else {
		final = parseFloat(final, 10).toFixed(2);
	}
	return final.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

Helpers.sortPaymentMethods = (a, b) => {
	return a["PaymentMethodId"] - b["PaymentMethodId"];
};

const numberWithCommas = x => {
	return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

Helpers.formatCurrency = number => {
	return numberWithCommas(Math.round(number * 100) / 100);
};

Helpers.arrayToObject = (array, keyField) =>
	array.reduce((obj, item) => {
		obj[item[keyField]] = item;
		return obj;
	}, {});

Helpers.arrayToObjectSingleCol = array =>
	array.reduce((obj, item) => {
		obj[item + ""] = item;
		return obj;
	}, {});

Helpers.capitalize = (str, lower) => {
	return (lower ? str.toLowerCase() : str).replace(/(?:^|\s)\S/g, function(a) {
		return a.toUpperCase();
	});
};

Helpers.getFriendlyNumbersForGTM = plan => {
    const details = {
      gtmPlanLocal: "",
      gtmPlanData: "",
      gtmPlanIntl: ""
    };

    details.gtmPlanLocal = plan.vmo_subplans[plan.vmo_subplans_ids_by_type["VOICE-LCL"]].vmo_ValueFormatted;
    details.gtmPlanData = plan.vmo_subplans[ plan.vmo_subplans_ids_by_type["DATA"]].vmo_ValueFormatted;
    details.gtmPlanIntl = plan.vmo_subplans[plan.vmo_subplans_ids_by_type["VOICE-INT"]].vmo_ValueFormatted;
    
	for (let k in details) {
		if (typeof details[k] === 'string') details[k] = details[k].toLowerCase();
	}
    return details;
}

Helpers.isAppleSafari = () => {
	let user_agent_str = navigator.userAgent.toLowerCase();
	if (
	  user_agent_str.indexOf("mac") !== -1 && 
	  user_agent_str.indexOf("safari/") !== -1 && 
	  user_agent_str.indexOf("chrome/") === -1
	) {
	  return true;
	} else {
	  return false;
	}
};

Helpers.isHTTPS = () => {
	return window.location.href.startsWith("https://");
};

Helpers.isAllowedKey = (e) =>
  (e.metaKey && e.code === 'KeyA') ||
  (e.metaKey && e.code === 'KeyV') ||
  (e.metaKey && e.code === 'KeyC') ||
  keycode(e) === 'delete' ||
  keycode(e) === 'backspace' ||
  keycode(e) === 'enter' ||
  keycode(e) === 'tab' ||
  keycode(e) === 'left command' ||
  keycode(e) === 'right command' ||
  keycode(e) === 'left' ||
  keycode(e) === 'right' ||
  ((keycode(e) === '0' ||
    keycode(e) === '1' ||
    keycode(e) === '2' ||
    keycode(e) === '3' ||
    keycode(e) === '4' ||
    keycode(e) === '5' ||
    keycode(e) === '6' ||
    keycode(e) === '7' ||
    keycode(e) === '8' ||
    keycode(e) === '9' ||
    keycode(e) === 'numpad 0' ||
    keycode(e) === 'numpad 1' ||
    keycode(e) === 'numpad 2' ||
    keycode(e) === 'numpad 3' ||
    keycode(e) === 'numpad 4' ||
    keycode(e) === 'numpad 5' ||
    keycode(e) === 'numpad 6' ||
    keycode(e) === 'numpad 7' ||
    keycode(e) === 'numpad 8' ||
    keycode(e) === 'numpad 9') &&
    !/\D/.test(+e.key));

Helpers.isDigit = (e) =>
  keycode(e) === '0' ||
  keycode(e) === '1' ||
  keycode(e) === '2' ||
  keycode(e) === '3' ||
  keycode(e) === '4' ||
  keycode(e) === '5' ||
  keycode(e) === '6' ||
  keycode(e) === '7' ||
  keycode(e) === '8' ||
  keycode(e) === '9' ||
  keycode(e) === 'numpad 0' ||
  keycode(e) === 'numpad 1' ||
  keycode(e) === 'numpad 2' ||
  keycode(e) === 'numpad 3' ||
  keycode(e) === 'numpad 4' ||
  keycode(e) === 'numpad 5' ||
  keycode(e) === 'numpad 6' ||
  keycode(e) === 'numpad 7' ||
  keycode(e) === 'numpad 8' ||
  keycode(e) === 'numpad 9';

Helpers.onlyDigits = (event) => {
  if (!Helpers.isAllowedKey(event)) {
    event.preventDefault();
  }
};

Helpers.removeDuplicates = (arr) => {
	const uniqueArray = [];
	const idSet = new Set();

	arr.forEach(obj => {
					if (!idSet.has(obj.ID)) {
									uniqueArray.push(obj);
									idSet.add(obj.ID);
					}
	});

	return uniqueArray;
}
Helpers.getInstalmentNoticeText = (isPlanEligible, planDuration)=> {
      const is12MonthPlan = planDuration === 12
      if(isPlanEligible && is12MonthPlan ) return 'CASHEW_INSTALMENTS_SUMMARY_NOTICE_12'
      if(!isPlanEligible && is12MonthPlan ) return 'CASHEW_INSTALMENTS_SUMMARY_NOTICE_3'
      if(isPlanEligible && !is12MonthPlan ) return 'CASHEW_INSTALMENTS_PLAN_SELECTOR_NOT_ELIGIBLE'
      else return 'CASHEW_INSTALMENTS_PLAN_SELECTOR_NOT_ELIGIBLE'
}

function isAppleDevice() {
	const userAgent = navigator.userAgent || navigator.vendor || window.opera;
	// Check for iOS devices (iPhone, iPad, iPod)
	const isIOS = (/Mac|iPad|iPhone|iPod/.test(userAgent) || 'ontouchstart' in window || navigator.MaxTouchPoints > 0) && !window.MSStream;
	// Check for macOS devices
	const isMacOS = /Macintosh/.test(userAgent) || navigator.platform === 'MacIntel';
	// Check apple Window values
	const supportsApple = !!window.AppleID || !!window.ApplePaySession;
	return isIOS || isMacOS || supportsApple;
}

export default Helpers;
export {numberWithCommas, readableStorage, isAppleDevice};